import React from 'react';
import ReactDOM from 'react-dom/client';
import { BrowserRouter } from 'react-router-dom';
import { QueryClient, QueryClientProvider } from '@tanstack/react-query';
import '@ds/styles.css';
import '@/styles/app.css';
import { installLucideIcons } from '@/ds/lucide';
import { App } from '@/App';

// Иконки должны быть на месте до первой отрисовки: компонент Icon читает их синхронно.
installLucideIcons();

const queryClient = new QueryClient({
  defaultOptions: {
    queries: { refetchOnWindowFocus: false, retry: false },
  },
});

const root = document.getElementById('root');
if (!root) throw new Error('Не найден корневой элемент');

ReactDOM.createRoot(root).render(
  <React.StrictMode>
    <QueryClientProvider client={queryClient}>
      <BrowserRouter>
        <App />
      </BrowserRouter>
    </QueryClientProvider>
  </React.StrictMode>,
);
